import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-groups-modal',
  templateUrl: './manage-groups-modal.component.html',
  styleUrls: ['./manage-groups-modal.component.scss']
})
export class ManageGroupsModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
